import src from "IMAGE";
export default { src, width: 1440, height: 240, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAIAAABsYngUAAAAIUlEQVR42mOonr+tuGtpRfO8orKerOySwMAwW1sna2tHAJQoCjTOCikjAAAAAElFTkSuQmCC", blurWidth: 8, blurHeight: 1 }
